import firebase from 'firebase';

const firebaseConfig = {
    apiKey: "AIzaSyDBH3RV09vLNd8jJKJWwSNhGK7aZJJlOBg",
    authDomain: "cloneslackapp.firebaseapp.com",
    databaseURL: "https://cloneslackapp.firebaseio.com",
    projectId: "cloneslackapp",
    storageBucket: "cloneslackapp.appspot.com",
    messagingSenderId: "5184231657",
    appId: "1:5184231657:web:9264b9cffda54fddbcf878",
    measurementId: "G-WSFK04VEZG"
  };

  const firebaseApp = firebase.initializeApp(firebaseConfig);
  const db = firebaseApp.firestore();
  const auth = firebase.auth();
  const provider = new firebase.auth.GoogleAuthProvider();

  export { auth, provider };
  export default db;